<div id="alert-message" data-test-id="alertMessage" [class]="alert.className" *ngIf="alert?.show"
  [ngClass]="{'PPP-wrapper': PPPflag, '': !PPPflag}">
  <a id='alert-message-close-link' data-test-id='alert-message-close-link' class="close" data-dismiss="alert"
    aria-label="close" (click)="close()">&times;</a>
  {{alert.message}}
</div>
